(function(){
  const AC=window.AC||{};
  const $=(s,r)=>(r||document).querySelector(s);
  const $$=(s,r)=>Array.from((r||document).querySelectorAll(s));

  /* money, honoring the shop's money format */
  function money(cents){
    const fmt=AC.moneyFormat||"${{amount}}";
    const n=cents/100;
    const commas=s=>s.replace(/\B(?=(\d{3})+(?!\d))/g,",");
    return fmt.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g,"."))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,n.toFixed(2).replace(".",",").replace(/\B(?=(\d{3})+(?!\d))/g,"."))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,commas(Math.round(n).toString()))
      .replace(/\{\{\s*amount\s*\}\}/g,commas(n.toFixed(2)))
      .replace(/<[^>]+>/g,"");
  }
  function setCartCount(n){$$("[data-cart-count]").forEach(el=>el.textContent=n);}

  /* ===== buy box ===== */
  function initBuyBox(box){
    if(box.dataset.init)return;box.dataset.init="1";
    let data;try{data=JSON.parse($("[data-buy-data]",box).textContent);}catch(e){console.error("buy-box data",e);return;}
    const form=$("[data-product-form]",box);if(!form)return;
    const section=box.closest(".buy")||box.parentElement;
    const gallery=$(".gallery",section);
    const sticky=$("[data-sticky]",section);
    const packEls=$$("[data-pack]",form);
    if(!packEls.length||!data.variants.length)return;
    const variantOf=el=>data.variants.find(v=>String(v.id)===el.dataset.variant)||data.variants[0];
    let pack=packEls.find(el=>el.querySelector("input").checked)||packEls[0];
    let qty=1,userPickedImage=false;
    const freq=()=>{const r=$('input[value="sub"]',form);return r&&r.checked?"sub":"one";};

    function showImg(id){
      if(!gallery||!id)return;
      const imgs=$$(".gallery-main img",gallery);
      if(!imgs.some(i=>String(i.dataset.i)===String(id)))return;
      imgs.forEach(i=>{const on=String(i.dataset.i)===String(id);i.classList.toggle("on",on);if(on&&i.loading==="lazy")i.loading="eager";});
      $$(".thumbs button",gallery).forEach(b=>{const on=String(b.dataset.i)===String(id);b.classList.toggle("on",on);if(on&&b.scrollIntoView)b.scrollIntoView({block:"nearest",inline:"center",behavior:"smooth"});});
    }
    function render(){
      const v=variantOf(pack);
      const pq=Math.max(1,+pack.dataset.qty||1);
      const unit=v.price*pq;
      const subUnit=(data.plan&&v.plan!=null)?v.plan*pq:null;
      const isSub=freq()==="sub"&&subUnit!=null;
      const total=(isSub?subUnit:unit)*qty;
      const set=(sel,txt)=>{const el=$(sel,form);if(el)el.textContent=txt;};
      if(subUnit!=null){const pct=Math.round((1-subUnit/unit)*100);const t=$("[data-sub-title]",form);if(t&&t.dataset.tpl)t.textContent=t.dataset.tpl.replace("[percent]",pct);}
      set("[data-qty-out]",qty);
      set("[data-total]",money(total));
      packEls.forEach(el=>el.classList.toggle("on",el===pack));
      $$(".freq .opt",form).forEach(el=>el.classList.toggle("on",el.querySelector("input").checked));
      $("[data-variant-input]",form).value=v.id;
      $("[data-qty-input]",form).value=pq*qty;
      const planInput=$("[data-plan-input]",form);planInput.disabled=!isSub;planInput.value=isSub?data.plan:"";
      const atc=$("[data-atc]",form),lbl=$("[data-atc-label]",form);
      if(!lbl.dataset.label)lbl.dataset.label=lbl.textContent;
      atc.disabled=!v.available;lbl.textContent=v.available?lbl.dataset.label:"Sold out";
      const note=$("[data-ship-note]",box);
      if(note&&data.shipNoteFree&&data.freeFrom>0)note.textContent=total>=data.freeFrom?data.shipNoteFree:data.shipNote;
      if(sticky){$("[data-sticky-price]",sticky).textContent=money(total);$("[data-sticky-name]",sticky).textContent=pack.dataset.name||"";}
      if(!userPickedImage&&v.media&&String(v.media)!=="0")showImg(v.media);
    }
    packEls.forEach(el=>{const inp=el.querySelector("input");inp.addEventListener("change",()=>{if(inp.checked){pack=el;userPickedImage=false;render();}});});
    $$('input[name^="freq-"]',form).forEach(r=>r.addEventListener("change",render));
    $$("[data-q]",form).forEach(b=>b.addEventListener("click",()=>{qty=Math.min(99,Math.max(1,qty+(+b.dataset.q)));render();}));
    if(gallery){
      $$(".thumbs button",gallery).forEach(b=>b.addEventListener("click",()=>{userPickedImage=true;showImg(b.dataset.i);}));
      const main=$(".gallery-main",gallery);let tx=null;
      const step=d=>{const imgs=$$("img",main);if(imgs.length<2)return;let i=imgs.findIndex(x=>x.classList.contains("on"));i=(i+d+imgs.length)%imgs.length;userPickedImage=true;showImg(imgs[i].dataset.i);};
      main.addEventListener("touchstart",e=>{tx=e.touches[0].clientX;},{passive:true});
      main.addEventListener("touchend",e=>{if(tx===null)return;const dx=e.changedTouches[0].clientX-tx;tx=null;if(Math.abs(dx)>40)step(dx<0?1:-1);},{passive:true});
    }
    if(sticky)$("[data-sticky-cta]",sticky).addEventListener("click",()=>{box.scrollIntoView({behavior:"smooth",block:"start"});});

    form.addEventListener("submit",async e=>{
      e.preventDefault();
      const v=variantOf(pack);
      const atc=$("[data-atc]",form),lbl=$("[data-atc-label]",form);
      const item={id:v.id,quantity:+$("[data-qty-input]",form).value||1};
      if(freq()==="sub"&&data.plan&&v.plan!=null)item.selling_plan=Number(data.plan);
      atc.setAttribute("data-loading","");lbl.textContent="Adding…";
      try{
        const r=await fetch((AC.addUrl||"/cart/add")+".js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:[item]})});
        if(!r.ok){const j=await r.json().catch(()=>({}));throw new Error(j.description||j.message||"Could not add to cart");}
        const c=await fetch(AC.cartJson||"/cart.js").then(x=>x.json());setCartCount(c.item_count);
        if((AC.afterAdd||"cart")==="cart"){window.location.href=AC.cartUrl||"/cart";return;}
        lbl.textContent="Added to cart";
        setTimeout(()=>{atc.removeAttribute("data-loading");render();},1600);
      }catch(err){
        atc.removeAttribute("data-loading");lbl.textContent=err.message||"Try again";
        setTimeout(render,2500);
      }
    });
    render();

    /* sticky bar on mobile once the add button scrolls out */
    if(sticky&&"IntersectionObserver" in window){
      const atc=$("[data-atc]",form);
      new IntersectionObserver(en=>{const e=en[0];const on=!e.isIntersecting&&e.boundingClientRect.top<0;sticky.classList.toggle("show",on);sticky.setAttribute("aria-hidden",String(!on));},{threshold:0}).observe(atc);
    }
  }
  $$("[data-buy-box]").forEach(initBuyBox);
  document.addEventListener("shopify:section:load",e=>{$$("[data-buy-box]",e.target).forEach(initBuyBox);});

  /* reels arrows */
  $$(".reels-btn").forEach(b=>b.addEventListener("click",()=>{const track=b.closest(".reels").querySelector(".reels-track");const w=track.querySelector(".reel").getBoundingClientRect().width+16;track.scrollBy({left:w*2*parseInt(b.dataset.dir,10),behavior:"smooth"});}));

  /* cart page qty buttons */
  $$(".cart-line").forEach(line=>{
    const inp=$("[data-line-qty]",line);if(!inp)return;
    const submit=()=>{const f=inp.closest("form");const b=document.createElement("input");b.type="hidden";b.name="update";f.appendChild(b);f.submit();};
    $("[data-line-inc]",line).addEventListener("click",()=>{inp.value=Number(inp.value)+1;submit();});
    $("[data-line-dec]",line).addEventListener("click",()=>{inp.value=Math.max(0,Number(inp.value)-1);submit();});
    inp.addEventListener("change",submit);
  });

  /* address country selects */
  $$('select[name="address[country]"]').forEach(s=>{const d=s.dataset.default;if(d)s.value=d;});

  /* mobile menu */
  const mb=$("#menu-btn"),mm=$("#mobile-menu");
  if(mb&&mm){mb.addEventListener("click",()=>{const open=mm.dataset.open!=="true";mm.dataset.open=String(open);mb.setAttribute("aria-expanded",String(open));mb.setAttribute("aria-label",open?"Close menu":"Open menu");});
  $$("a",mm).forEach(a=>a.addEventListener("click",()=>{mm.dataset.open="false";mb.setAttribute("aria-expanded","false");}));}
})();
